// ─── Calendrier de l'espace — modale de création / édition ───────
// Portée par CalendrierActifContext (au NIVEAU RACINE de l'app), car une
// <Feuille> rendue dans le ScrollView du Profil serait mal placée sur natif.
// Ouverte via useCalendrierActif().ouvrirEditionCalendrier(cal|null).
import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI, useT, Feuille, SelecteurEmoji, ChoixPuces } from '@mop/core';
import { TYPES_CALENDRIER } from './services/calendriersEspace';

export default function FeuilleCalendrier({ visible, initial, busy, onEnregistrer, onFermer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [nom, setNom] = useState('');
  const [emoji, setEmoji] = useState('📅');
  const [type, setType] = useState('general');

  useEffect(() => {
    if (!visible) return;
    setNom(initial?.nom || '');
    setEmoji(initial?.emoji || '📅');
    setType(initial?.type || 'general');
  }, [visible, initial]);

  const nomT = nom.trim();
  const modifie = !initial?.id
    ? !!nomT
    : (nomT !== (initial?.nom || '') || emoji !== (initial?.emoji || '📅') || type !== (initial?.type || 'general'));
  const valide = !!nomT && modifie && !busy;

  const enregistrer = () => { if (!valide) return; onEnregistrer?.({ nom: nomT, emoji, type }); };
  const action = { icone: initial?.id ? '💾' : '＋', onPress: enregistrer, disabled: !valide, label: t('commun.enregistrer') };

  return (
    <Feuille visible={visible} titre={initial?.id ? t('calendrier.modifierCal') : t('calendrier.nouveauCal')}
      emoji={emoji} hauteur={0.82} onFermer={onFermer} action={action}>
      <Text style={s.lbl}>{t('listes.nom')}</Text>
      <TextInput style={s.input} value={nom} onChangeText={setNom}
        placeholder={t('calendrier.nomPlaceholder')} placeholderTextColor={UI.faint} />

      <Text style={s.lbl}>{t('historique.dType')}</Text>
      <ChoixPuces value={type} onChange={setType}
        options={TYPES_CALENDRIER.map(it => ({ id: it.id, label: `${it.emoji} ${t('calendrier.typeCal_' + it.id)}` }))} />

      <Text style={s.lbl}>{t('profil.icone')}</Text>
      <SelecteurEmoji inline avecRecherche valeur={emoji} onChange={setEmoji} />
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  lbl: { fontSize: 12, fontWeight: '700', color: UI.muted, marginTop: 12, marginBottom: 7 },
  input: { backgroundColor: UI.champ, borderRadius: 10, paddingHorizontal: 12, paddingVertical: 11, fontSize: 15, color: UI.ink, borderWidth: 0.5, borderColor: UI.champBord },
  puces: { flexDirection: 'row', flexWrap: 'wrap', gap: 7 },
  puce: { paddingHorizontal: 12, paddingVertical: 8, borderRadius: 999, backgroundColor: UI.champ, borderWidth: 0.5, borderColor: UI.champBord },
  puceOn: { backgroundColor: UI.accentTint, borderColor: UI.accent },
  puceTxt: { fontSize: 12.5, color: UI.ink, fontWeight: '600' },
  puceTxtOn: { color: UI.accent, fontWeight: '800' },
});
